import { Component, OnInit } from '@angular/core';
import { MasterService } from 'app/services/master/master.service';
import { MstSystemAdminModel } from 'app/model/mst.systemAdmin.model';
import { FormBaseComponent } from 'app/components/form/form-base.component';

@Component({
    selector: 'form-system-admin',
    templateUrl: './form-system-admin.component.html',
    styleUrls: ['./form-system-admin.component.scss']
})
export class FormSystemAdminComponent extends FormBaseComponent implements OnInit {


    systemAdmins: Array<
        MstSystemAdminModel & {
            newLine?: boolean; 
            confirmPass?: string;
            validName?: boolean;
            validMail?: boolean;
            validPass?: boolean;
            validConfirmPass?: boolean;
        }>


    validAll : boolean;

    /** 入力モード */
    confirmation: boolean;

    constructor(private masterService: MasterService) {
        super();
     }

    /**
     * 初期処理
     */
    async ngOnInit() {
        try {
            this.loading.emit(true);
            this.confirmation = false;
            this.systemAdmins = await this.masterService.getSystemAdmins();
            this.systemAdmins.forEach(item => {
                item.newLine = false;
                item.validName = false;
                item.validMail = false;
                item.validPass = false;
                item.validConfirmPass = false;
            })
            this.validAll = false;

        } catch(err) {
            this.alert('danger', err.message);
        } finally {
            this.loading.emit(false);
        }
    }

    /**
     * 新規行追加
     */
    addRow() {
        let line = Object.assign(new MstSystemAdminModel(), {newLine: true, confirmPass: ''});
        line.pass = '';

        this.systemAdmins.push(line);
    }


    /**
     * 入力チェック処理
     */
    validateForm(form) {
        
        if (form.invalid)  {
            this.validAll = true;
            return;
        }

        // 確認用パスワードチェック
        for (let item of this.systemAdmins) {
            if (item.newLine && !item.del && item.pass != item.confirmPass) {
                return;
            }
        }

        // 重複チェック
        let tmpMail = [];
        for (let item of this.systemAdmins) {
            if (item.del) continue;
            if (tmpMail.find(i => i == item.mail)) {
                this.alert('danger', '重複のデータが存在しています。', 5000);
                return;
            }
            tmpMail.push(item.mail);
        }
        
        // 更新対象存在チェック
        for (let item of this.systemAdmins) {
            if ((item.newLine && !item.del) || (!item.newLine && item.del)) {
                this.confirmation = true;
                return;
            }
        }
    }

    /**
     * 入力内容を更新する
     */
    async updateForm() {

        try {
            this.loading.emit(true);

            let updateList: Array<MstSystemAdminModel> = [];

            this.systemAdmins.forEach(item => {

                if ((item.newLine && !item.del) || (!item.newLine && item.del)) {
                    updateList.push({
                        mail: item.mail,
                        name: item.name,
                        pass: item.pass,
                        del: item.del
                    });
                }
            });
            await this.masterService.updateSystemAdmins(updateList);
            
            this.alert('success', ' システム管理者を更新しました。', 7000);

            await this.ngOnInit();

        } catch(err) {
            this.alert('danger', err.message);
            this.confirmation = true;
            console.error(err);
        } finally {
            this.loading.emit(false);
        }
    }

    trackByIndex(index: number, value: number) {
        return index;
    }

}



// WEBPACK FOOTER //
// E:/02_workspace/TenneT/git/tennet_suggestion_box/client/src/app/components/form-setting/form-system-admin.component.ts